import React, { Component } from 'react';

import { Button } from 'components/button';
import { Checklist } from 'components/checklist';
import { InputDropdown } from 'components/input';
import { I18n, translate } from 'components/translate';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { UserManagerService } from 'modules/userManager';
import { COLUMNS_LIMIT, COLUMNS_LIST } from 'modules/userManager/constants';
import PropTypes from 'prop-types';

import './UsersListColumnsManager.scss';

@translate()
@inject((stores) => ({
  columns: stores.UserManagerStore.columns,
  isMobile: stores.UiStore.isMobile
}))
@observer
class UsersListColumnsManager extends Component {
  static propTypes = {
    columns: MobxPropTypes.arrayOrObservableArray,
    isMobile: PropTypes.bool,
    t: PropTypes.func
  };

  columnsListMemoized = Object.values(COLUMNS_LIST).filter(
    (item) => item.value !== COLUMNS_LIST.USER_NAME.value
  );

  state = {
    columnsChecked: this.props.columns
  };

  get listFormatted() {
    const { columnsChecked } = this.state;
    const { t, isMobile } = this.props;
    const { REASON } = COLUMNS_LIST;

    let columnList = this.columnsListMemoized;

    if (!isMobile) {
      columnList = this.columnsListMemoized?.filter(
        ({ value }) => value !== REASON?.value
      );
    }

    const list = columnList.map((item) => ({
      value: item.value,
      name: t(item.label),
      checked: columnsChecked.includes(item.value)
    }));

    return list;
  }

  update() {
    const { columnsChecked } = this.state;

    UserManagerService.changeColumnsView(columnsChecked);
  }

  cancel() {
    this.setState({ columnsChecked: this.props.columns });
  }

  changeColumns = (e) => {
    this.setState({ columnsChecked: e.target.value });
  };

  render() {
    return (
      <InputDropdown
        preventCloseOnDropdownListClick
        className="users__list__columns__manager"
        selected={<I18n label="general.columns" />}
      >
        <Checklist
          items={this.listFormatted}
          onChange={this.changeColumns}
          selectedLimit={COLUMNS_LIMIT}
        >
          <Checklist.SelectedItems />
          <Checklist.Items />
        </Checklist>

        <div className="users__list__columns__manager__actions">
          <InputDropdown.Close>
            <Button
              outline
              transparent
              size="small"
              onClick={this.update.bind(this)}
            >
              <I18n label="general.update" />
            </Button>
          </InputDropdown.Close>

          <InputDropdown.Close>
            <Button type="cancel" size="small" onClick={this.cancel.bind(this)}>
              <I18n label="general.cancel" />
            </Button>
          </InputDropdown.Close>
        </div>
      </InputDropdown>
    );
  }
}

export default UsersListColumnsManager;
